import React, { useEffect, useState, useRef } from 'react'
//Helpers
import { getCover, getPhotos, getQuality, getVideos } from '@helpers/helper.rendering'
import {
  getBluePrints,
  getRealAddress,
  getFakeAddres,
  getRegion,
  getTours,
  getLocation,
} from '@helpers/helper.properties'
import Gallery from '@components/fsLightboxGallery'
import { Action, RealEstateDataPageComponentData, StateGallerySlice } from 'types'
import { useDispatch, useSelector } from 'react-redux'
import { setTogglerImages } from '@slices/galerySlice'
import MultiActionBar from '@components/multiactionBarDetail/1'
import useQueryProperty from '@hooks/useQueryProperty'
import Slider from 'react-slick'
import { useGetPushQuery } from '@apis/mediacore/push'
import {
  getActionByType,
  getCodeFromType,
  getCodes,
  getQueryEventTracker,
} from '@helpers/helper.actions'
import { useLocation } from '@reach/router'
import { informCustomEvent } from '@helpers/helper.analytics'
import { useCreateApplicationMutation as useSendTrackerEvent } from '@apis/mediacore/tracker'

const isBrowser = typeof window !== 'undefined'

interface ExternalProps {
  propertyID: string
}

type CombinedProps = RealEstateDataPageComponentData & ExternalProps

const JumbotronProperty_2 = ({
  propertyID,
  multiActionBar: multiActionBarProp,
  align,
  upperCaseLink,
  is_short,
  global_data,
  hidden,
}: CombinedProps) => {
  const { data: allPropertyData, isLoading } = useQueryProperty(
    propertyID,
    global_data.pageConfig.keys.tokko,
  )

  console.log(multiActionBarProp)

  const {
    togglerVideos,
    togglerImages,
    togglerTours,
    togglerBlueprints,
    currentlyImage,
    currentlyBluePrint,
  } = useSelector((state: { gallery: StateGallerySlice }) => state.gallery)!

  const dispatch = useDispatch()

  const clientHeight: number | undefined = isBrowser
    ? document?.getElementById('header')?.clientHeight
    : 0

  const [height, setHeight] = useState(0)

  const isCompiler = process.env.GATSBY_IS_SITE_COMPILER === 'true'
  const { pathname } = useLocation()

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    fade: false,
    slidesToShow: 1,
    slidesToScroll: 1,
  }
  const sliderRef = useRef<any>()

  const currentPage = global_data.content.pages?.find(
    (page) =>
      (pathname.replaceAll('/', '') === page.path.replaceAll('/', '') && !isCompiler) ||
      (isCompiler &&
        pathname !== '/' &&
        pathname.replace(global_data.divisionPath!, '').replaceAll('/', '') ===
          page.path.replaceAll('/', '')) ||
      (pathname.includes('/emprendimiento/') && page.path === '/desarrollo_detalle') ||
      (pathname.includes('/propiedad/') && page.path === '/propiedad_detalle') ||
      (pathname.includes('/novedad/') && page.path === '/novedad_detalle'),
  )

  const { data: allPushData, isLoading: loading } = useGetPushQuery({
    page: currentPage?.id || '',
    data_id: propertyID || '',
  })
  const slider_action = getActionByType(
    allPushData,
    getCodeFromType('Slider de Imagenes Encabezado'),
  )
  const image_action = getActionByType(allPushData, getCodeFromType('Imagen Encabezado'))
  const video_action = getActionByType(allPushData, getCodeFromType('Video Encabezado'))

  const [sendTrackerEvent] = useSendTrackerEvent()

  useEffect(() => {
    // if (loading) return
    const headers = document.querySelectorAll('header')
    let height_headers = 0
    // Mostrar los tamaños de cada header
    setTimeout(() => {
      headers.forEach((header) => {
        const rect = header.getBoundingClientRect()
        height_headers += rect.height
      })
      setHeight(height_headers)
    }, 1000)
  }, [])

  useEffect(() => {
    if (allPropertyData) {
      if (video_action.length > 0) {
        informCustomEvent('SHOW_' + currentPage?.id + '_' + propertyID + '_' + video_action[0].id)
        sendTrackerEvent(
          getQueryEventTracker({
            page: currentPage!,
            action: video_action[0],
            type: 'SHOW',
            data_id: propertyID,
            url: location.href,
            extra_title: allPropertyData?.address,
          }),
        )
      }
      if (image_action.length > 0) {
        informCustomEvent('SHOW_' + currentPage?.id + '_' + propertyID + '_' + image_action[0].id)
        sendTrackerEvent(
          getQueryEventTracker({
            page: currentPage!,
            action: image_action[0],
            type: 'SHOW',
            data_id: propertyID,
            url: location.href,
            extra_title: allPropertyData?.address,
          }),
        )
      }
      if (slider_action.length > 0) {
        informCustomEvent('SHOW_' + currentPage?.id + '_' + propertyID + '_' + slider_action[0].id)
        sendTrackerEvent(
          getQueryEventTracker({
            page: currentPage!,
            action: slider_action[0],
            type: 'SHOW',
            data_id: propertyID,
            url: location.href,
            extra_title: allPropertyData?.address,
          }),
        )
      }
    }
  }, [allPropertyData])

  //PUSH MODULE
  const RenderPushSlider = () => {
    return (
      <div
        id="hero-main"
        style={{ zIndex: 0, height: `calc(100vh - ${clientHeight}px)` }}
        className="banner-main a inyected"
      >
        <Slider
          {...settings}
          ref={sliderRef}
        >
          {slider_action
            .at(0)
            ?.files.map(
              ({ file, url_destiny }: { file: string; url_destiny: string }, index: number) => (
                <div
                  key={index}
                  className="position-relative "
                >
                  <div
                    className={`${url_destiny && 'cursor-pointer'}`}
                    onClick={() => (url_destiny ? window?.open(url_destiny) : null)}
                  >
                    <div className="opacity"></div>
                    <img
                      src={file}
                      style={{ maxHeight: `calc(100vh - ${clientHeight}px)` }}
                      className="image-push"
                      alt=""
                    />
                  </div>
                </div>
              ),
            )}
        </Slider>
        <div className={'arrows-left onTop zindex-1'}>
          <div
            className="arrow"
            onClick={() => sliderRef.current.slickPrev()}
          >
            {' '}
            <i></i> <i></i>
          </div>
        </div>
        <div className={'arrows-right onTop zindex-1'}>
          <div
            className="arrow"
            onClick={() => sliderRef.current.slickNext()}
          >
            {' '}
            <i></i> <i></i>{' '}
          </div>
        </div>
      </div>
    )
  }

  const RenderPushImage = () => {
    return (
      <img
        style={{ maxHeight: `calc(100vh - ${clientHeight}px)`, height: '100%' }}
        className={
          'image-push w-100 object-fit-cover ' +
          (image_action.at(0)?.url_destiny && 'cursor-pointer')
        }
        src={image_action.at(0)?.files.at(0)?.file}
        alt=""
      />
    )
  }

  const RenderPushVideo = () => {
    return (
      <video
        onClick={() => goTo()}
        className={'d-lg-block w-100 object-fit-cover '}
        style={{ maxHeight: `calc(100vh - ${clientHeight}px)`, height: '100%' }}
        loop
        autoPlay
        muted
      >
        <source
          src={
            isDesktop()
              ? video_action[0].files.find(
                  (video: { device: string }) => video.device === 'desktop',
                )?.file || video_action[0].files[0].file
              : video_action[0].files.find((video: { device: string }) => video.device === 'mobile')
                  ?.file || video_action[0].files[0].file
          }
          type="video/mp4"
        />
      </video>
    )
  }

  const goTo = () => {
    if (video_action[0].url_destiny) {
      if (isBrowser) {
        window.open(
          video_action[0].url_destiny + video_action[0].text_utm,
          '_blank',
          'noopener,noreferrer',
        )
      }
      informCustomEvent('PUSH_' + currentPage?.id + '_' + propertyID + '_' + video_action[0].id)
      sendTrackerEvent(
        getQueryEventTracker({
          page: currentPage!,
          action: video_action[0],
          type: 'PUSH',
          data_id: propertyID,
          url: location.href,
          extra_title: allPropertyData?.address,
        }),
      )
    }
  }

  const validateGoTo = () => {
    if (video_action.length > 0) {
      goTo()
    } else if (image_action.length > 0) {
      goToImage(image_action[0])
    } else if (slider_action.length > 0) {
      goToImage(slider_action[0], 0)
    }
  }

  const goToImage = (action: Action, index?: number) => {
    if (index !== undefined && action?.files[index].url_destiny) {
      window?.open(action?.files[index].url_destiny)
    } else if (action.url_destiny) {
      window?.open(action?.url_destiny)
    }
    informCustomEvent('PUSH_' + currentPage?.id + '_' + propertyID + '_' + action.id)
    sendTrackerEvent(
      getQueryEventTracker({
        page: currentPage!,
        action: action,
        type: 'PUSH',
        data_id: propertyID,
        url: location.href,
        extra_title: allPropertyData?.address,
      }),
    )
  }

  const isDesktop = () => (screen.width < 992 ? false : true)

  const notpush =
    image_action.length === 0 && video_action.length === 0 && slider_action.length === 0

  return (
    <section
      style={{ height: `calc(100vh - ${clientHeight}px)` }}
      className={
        'ficha-main b prop overflow-hidden ficha emprendimiento pt-0 ' +
        (isLoading ? 'skeleton' : '') +
        (align === 'right' ? ' bar-vertical ' : '')
      }
      onClick={() => validateGoTo}
    >
      <article>
        <div
          className="item"
          id="dev-gallery"
          style={{ height: `calc(100vh)` }}
          onClick={() => notpush && dispatch(setTogglerImages())}
        >
          {image_action.length > 0 && <RenderPushImage />}
          {video_action.length > 0 && <RenderPushVideo />}
          {slider_action.length > 0 && <RenderPushSlider />}
          {!isLoading && notpush && (
            <img
              src={getQuality(getCover(allPropertyData?.photos))}
              alt=""
            />
          )}
          <div className={'center-text ' + (is_short ? 'biger-text' : '')}>
            <div className="text-center d-flex flex-column pb-5 pb-lg-0">
              {!hidden && (
                <h3 className={'order-lg-2  mb-5 mt-1'}>
                  {allPropertyData?.development?.name
                    ? allPropertyData?.development?.name + ', '
                    : ''}
                  {getRegion(allPropertyData)}{' '}
                </h3>
              )}
              <h1>
                {upperCaseLink ? getFakeAddres(allPropertyData) : getRealAddress(allPropertyData)}
              </h1>
            </div>
          </div>
        </div>
        {/* <MultiActionBar skeleton={isLoading} data={allPropertyData} /> */}
        {multiActionBarProp && (
          <MultiActionBar
            vertical={align === 'right' ? true : false}
            itemsBar={multiActionBarProp}
            data={allPropertyData}
            skeleton={isLoading}
            propertyID={propertyID}
            global_data={global_data}
          />
        )}
        {getVideos(allPropertyData?.videos).length > 0 ? (
          <Gallery
            index={1}
            sources={getVideos(allPropertyData?.videos)}
            slide={1}
            type={'video'}
            toggleEvent={togglerVideos}
            data={allPropertyData}
          />
        ) : null}
        {getPhotos(allPropertyData).length > 0 ? (
          <Gallery
            index={2}
            sources={getPhotos(allPropertyData?.photos)}
            slide={currentlyImage}
            type={'image'}
            toggleEvent={togglerImages}
            data={allPropertyData}
          />
        ) : null}
        {getTours(allPropertyData).length > 0 ? (
          <Gallery
            index={3}
            sources={getTours(allPropertyData)}
            slide={1}
            type={'tour'}
            toggleEvent={togglerTours}
            data={allPropertyData}
          />
        ) : null}
        {getBluePrints(allPropertyData).length > 0 ? (
          <Gallery
            index={4}
            sources={getBluePrints(allPropertyData)}
            slide={currentlyBluePrint}
            type={'blueprint'}
            toggleEvent={togglerBlueprints}
            data={allPropertyData}
          />
        ) : null}
      </article>
    </section>
  )
}

export default JumbotronProperty_2
